import { isEmpty } from 'lodash';
export default {
  type: 'form_usage',
  config: {
    relationships: {
      form: {
        type: 'form'
      },
      form_utilizer: {
        type: function type(_, data) {
          if (isEmpty(data.form_utilizer.type)) {
            throw Error('Missing form utilizer type: provider or network or plan');
          }
          return data.form_utilizer.type;
        }
      }
    }
  }
};
//# sourceMappingURL=form_usage.js.map